<template>
  <div>
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      title="管理人天"
      :enableDrag="true"
      width="550px"
      @close="cancel"
      v-loading="loading"
    >
      <span style="color: red; font-size: 14px;">注：如事项中含跨月工时，请分两次填写，事件时间选择对应月份的时间。
        <br/>
        例如：2月28日~3月4日这周工时，可分两次填报2月28日（1天），3月4日（4天）</span>
      <dynamic-form
        :formConfig="formConfig"
        labelWidth="90px"
        v-model="form"
        @submit="save"
        @cancelForm="cancel"
        :disabled="openLook"
        :showSaveBtn="false"
        ref="subFormRef"
      ></dynamic-form>
    </drag-dialog>

    <drag-dialog
      :show="stepShow"
      :title="'审批人选择'"
      :width="'25%'"
      @close="stepShow = false">
      <PersonStep
        ref="personStepRef"
        :data="personStepData"
        @submit="submitConfirm"
        @close="stepShow = false"
      ></PersonStep>
    </drag-dialog>
  </div>
</template>

<script>
import DragDialog from '@/components/DragDialog'
import { deepClone } from '@/utils'
import PersonStep from "@/components/PersonStep";
import { getFlowNode } from "@/api/hrApproval";
import {save, submit} from '@/api/bill/manager-day';
import {getProjectSelectList} from '@/api/project';
export default {
  name: 'Form',
  inject: { parentThis: {default: {}} },
  components: {
    DragDialog,
    PersonStep
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      openLook: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            label: '管理事项',
            type: 'textarea',
            key: 'matter',
            placeholder: "请输入管理事项",
            rules: [
              {
                required: true,
                message: '管理事项不能为空',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '管理类型',
            type: 'select',
            key: 'type',
            placeholder: "请选择",
            optionsUrl: '/dict-detail',
            params: {
              code: 'manager_type'
            },
            events: {
              change: (val) => {
                if (val === 'manager_day_sales_dev' || val.indexOf('manager_day') === -1) {
                  this.$set(this.form, 'manDayType', '');
                } else {
                  this.$set(this.form, 'manDayType', '无');
                }
              }
            },
            rules: [
              {
                required: true,
                message: '管理类型不能为空',
                trigger: 'change'
              }
            ]
          },
          {
            label: '项目名',
            type: 'select',
            key: 'manDayType',
            placeholder: "请选择",
            options: [],
            rules: [
              {
                required: true,
                message: '项目名不能为空',
                trigger: 'change'
              }
            ]
          },
          {
            label: '事项人天',
            type: 'inputNumber',
            min: 0.1,
            key: 'manDay',
            hidden: false,
            placeholder: "请输入事项人天",
            rules: [
              {
                required: true,
                message: '事项人天不能为空',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '事项时间',
            type: 'date',
            subtype: 'datetime',
            key: 'matterTime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            placeholder: "请选择",
            rules: [{ required: true, message: '事项时间不能为空', trigger: 'change' }],
            pickerTime: {
              disabledDate: (time) => {
                const myDate = this.$parseDate()
                const date = myDate.toLocaleDateString().split('/')
                return time.getTime() > this.$parseDate(date).getTime()
              }
            }
            /* pickerTime: {
              disabledDate: (time) => {
                if (this.form.type === 'manager_day_sales_dev') {
                  const dateTime = new Date()
                  const dateStr = dateTime.getFullYear() + '-' + (dateTime.getMonth() + 1) + '-' + dateTime.getDate()
                  const date = this.$parseDate(dateStr)
                  return time.getTime() > date.getTime()
                } else {
                  return false
                }
              }
            } */
          },
          {
            label: '备注',
            type: 'textarea',
            maxlength: '200',
            key: 'remark',
            placeholder: '请输入备注'
          }
        ]
      },
      stepShow: false,
      personStepData: []
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (!val) {
          this.form = {}
        } else {
          this.$nextTick(() => {
            this.$refs.subFormRef.$refs.dynamicForm.clearValidate()
          })
        }
      }
    },
    'form.type': {
      handler(val, oldVal) {
        if (val && val !== oldVal) {
          this.form.matterTime = ''
          const idx = this.formConfig.formItemList.findIndex(i => i.key === 'manDayType')
          // 售前
          if (val === 'manager_day_sales_dev') {
            if (idx !== -1) {
              this.$set(this.formConfig.formItemList[idx], 'disabled', false)
              this.$set(this.formConfig.formItemList[idx], 'options', this.parentThis.contractList)
            }
          } else if (val.indexOf('manager_day') === -1) {
            // 产品
            if (idx !== -1) {
              this.$set(this.formConfig.formItemList[idx], 'disabled', false)
              let options = []
              const subData = {projectCategory: 'M', isClosed: 0}
              if (val !== 'manager_project_leave') {
                subData.code = val
              }
              getProjectSelectList(subData).then(res => {
                if (res.code === 200) {
                  if (res.data && res.data.length) {
                   options = res.data.map(i => {
                      i.label = `${i.name} - (${i.code})`
                      i.value = i.code
                      return i;
                    })
                  }
                }
                this.$set(this.formConfig.formItemList[idx], 'options', options)
              }).catch(() => {
                this.$set(this.formConfig.formItemList[idx], 'options', options)
              })
            }
          } else {
            if (idx !== -1) {
              this.$set(this.formConfig.formItemList[idx], 'disabled', true)
            }
          }
        }
      },
      immediate: true,
    }
  },
  methods: {
    // 取消关闭弹框
    cancel() {
      this.dialogVisible = false
    },
    // 提交 （添加/修改）
    submit() {
        this.loading = true
        getFlowNode({ from: 'manager_day', id: this.form.id }).then(res => {
          this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
            this.stepShow = true;
            this.personStepData = res.data;
            this.$nextTick(() => {
              this.$refs.personStepRef.formFlag = 'manager_day'
            })
          }
        }).finally(() => {
          this.$nextTick(() => {
            this.$refs.personStepRef.loadActivitySubmit = false
          })
          this.loading = false
        })
        /* const data = deepClone(this.form)
        data.billState = 2
        submit(data).then(res => {
          if (res.code === 200) {
            this.$message.success('提交成功！')
            this.parentThis.dataTableInit()
            this.loading = false
            this.dialogVisible = false
          }
        }).finally(() => {
          this.loading = false
        })*/
    },
    // 提交审批
    submitConfirm (val) {
      this.loading = true
      const obj = deepClone(this.form)
      obj.billState = 2
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = 'manager_day'
      submit(obj).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功！')
          this.parentThis.dataTableInit()
          this.loading = false
          this.stepShow = false
          this.dialogVisible = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    save() {
      this.loading = true
      const data = deepClone(this.form)
      data.billState = 3
      save(data).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功！')
          this.parentThis.dataTableInit()
          this.loading = false
          this.dialogVisible = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
